import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PaymentConfigProvider from '@providers/PaymentConfigProvider';
import UserProvider from './providers/UserProvider';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

const head = document.head;
const styleContainer = document.createElement('div');
head.appendChild(styleContainer);

const rfsCache= createCache({
  key: "refuse",
  prepend: true,
  nonce: "0198f57c-ef16-7efe-981a-028c7115221f",
  container: styleContainer,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <CacheProvider value={rfsCache}>
    <UserProvider>
      <PaymentConfigProvider>
        <App />
      </PaymentConfigProvider>
    </UserProvider>
  </CacheProvider>
);
